export const historyJobSource = [
  {
    id: 1,
    position: "Full Stack Developer",
    company: "PT. Pegadaian",
    location: "Jakarta Pusat",
    workType: "Onsite",
    employmentType: "Full-time",
    startDate: "August 2023",
    endDate: "Present",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Create & develop bad data service, cashier opening and closing scheduler and implementation on conventional and syariah passion",
      },
      {
        idDescription: 2,
        detail:
          "Developed Marsela services and implemented them in Passion Conventional & Syaria applications. Using Golang and Java languages",
      },
      {
        idDescription: 3,
        detail:
          "Create & develop new services for Selena application using Express JS language",
      },
      {
        idDescription: 4,
        detail:
          "Developments for new prospect module canvasing and CRO prospect in Single UI application using micro frontend (website mode & mobile mode)",
      },
      {
        idDescription: 5,
        detail:
          "And maintenance of UI/UX audit with Vue 3 language and State Management Pinia",
      },
    ],
  },
  {
    id: 2,
    position: "Front End Developer",
    company: "PT. Sinergi Informatika Semen Indonesia",
    location: "Gresik",
    workType: "WFH",
    employmentType: "Full-time",
    startDate: "September 2021",
    endDate: "August 2023",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Create & development Customer Relationship Management (CRM) project in MdExelent application using Vue 3 language and State Management Pinia",
      },
      {
        idDescription: 2,
        detail:
          "Create & development Customer Relationship Management (CRM) project in AksesToko application using Vue 3 language and State Management Pinia",
      },
      {
        idDescription: 3,
        detail:
          "Developed and implemented Portal Pelamar (Job Application Portal) for the Ministry of State-Owned Enterprises (Kementerian BUMN) using Vue 3 and Pinia State Management",
      },
      {
        idDescription: 4,
        detail:
          "Create & development E-Budget project application using Vue 2 with State Management Vuex",
      },
      {
        idDescription: 5,
        detail:
          "Create & development PPID KBUMN profile using PHP native languange",
      },
      {
        idDescription: 6,
        detail: "Create & development KBUMN profile using PHP native languange",
      },
    ],
  },
  {
    id: 3,
    position: "Front End Developer",
    company: "PT. Onklas Prima Indonesia",
    location: "Surabaya",
    workType: "WFH",
    employmentType: "Full-time",
    startDate: "July 2019",
    endDate: "August 2021",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Developed a comprehensive School Content Management System (CMS) for teachers and school administrators",
      },
      {
        idDescription: 2,
        detail:
          "Built an internal console application for managing and configuring the School CMS platform",
      },
      {
        idDescription: 3,
        detail: "Implemented a FAQ management system using Vue.js 2",
      },
      {
        idDescription: 4,
        detail:
          "Developed ABK Istimewa application for East Java Provincial Government (Pemprov Jatim) using Vue.js 2",
      },
      {
        idDescription: 5,
        detail:
          "Created a government monitoring CMS for Southeast Sulawesi Provincial Government",
      },
      {
        idDescription: 6,
        detail:
          "Developed KlasPustaka, a digital library management system for book borrowing and returns",
      },
      {
        idDescription: 7,
        detail:
          "Built KlasMonitoring, a student activity tracking and monitoring platform",
      },
      {
        idDescription: 8,
        detail: "Implemented KlasSign, a student attendance management system",
      },
      {
        idDescription: 9,
        detail:
          "Developed Kisah Klasik, a digital yearbook application for preserving school memories",
      },
    ],
  },
  {
    id: 4,
    position: "Front End Developer Intern",
    company: "PT. Sinergi Informatika Semen Indonesia",
    location: "Gresik",
    workType: "Onsite",
    employmentType: "Full-time",
    startDate: "February 2019",
    endDate: "Maret 2019",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Create & development SMILE application internal SIG Group using React JS",
      },
      {
        idDescription: 2,
        detail:
          "Research & implement PWA for SMILE application internal SIG Group",
      },
    ],
  },
  {
    id: 5,
    position: "Front End Developer",
    company: "Jjastip Jepang",
    location: "Surabaya",
    workType: "WFH",
    employmentType: "Freelance",
    startDate: "2024",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail: "Create new user interface using laravel on mobile mode",
      },
    ],
  },
  {
    id: 6,
    position: "Front End Developer",
    company: "Gocement",
    location: "Surabaya",
    workType: "WFH",
    employmentType: "Freelance",
    startDate: "2023",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Create platform marketplace for gocement using Nuxt JS framework",
      },
      {
        idDescription: 1,
        detail: "Implement SEO for gocement website",
      },
      {
        idDescription: 1,
        detail:
          "Create & Maintenance cms dahsboard for admin gocement website to manage user, product, transaction, promotion",
      },
    ],
  },
  {
    id: 7,
    position: "Front End Developer",
    company: "Artech",
    location: "Surabaya",
    workType: "WFH",
    employmentType: "Freelance",
    startDate: "2022",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Create landing pages for artech using vue 3 framework with responsive design",
      },
      {
        idDescription: 1,
        detail:
          "Create cms dashboar for admin artech to manage user, information customer, transaction and promotion for platform",
      },
    ],
  },
  {
    id: 8,
    position: "Front End Developer",
    company: "Klikchat",
    location: "Surabaya",
    workType: "WFH",
    employmentType: "Freelance",
    startDate: "2020",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Maintain and develop new features for the klikchat application using Vue 2",
      },
      {
        idDescription: 2,
        detail: "Migration from meteor JS to Vue 2",
      },
      {
        idDescription: 1,
        detail:
          "Maintain and develop new features for the klikchat business application using Vue 2",
      },
    ],
  },
  {
    id: 9,
    position: "Full Stack Developer",
    company: "Peduly",
    location: "Surabaya",
    workType: "WFH",
    employmentType: "Freelance",
    startDate: "2019",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail:
          "Create platform crowdfunding using laravel framework with responsive design and database mysql",
      },
      {
        idDescription: 2,
        detail: "Implement payment gateway using midtrans for payment method",
      },
      {
        idDescription: 3,
        detail:
          "Create cms dashboard for admin to manage user, campaign, monitoring transaction",
      },
    ],
  },
];
